import { apiVersion } from '../apis.const';
import { baseApi } from '../base.api';

/**
 * Create APIs
 */
export const onboardingApi = baseApi.injectEndpoints({
  overrideExisting: false,

  endpoints: (build) => ({
    fetchOnboarding: build.query<FetchOnboardingRes, FetchOnboardingReq>({
      query: ({ orgSlug }) => ({
        url: `/${orgSlug}/${apiVersion}/onboarding`,
      }),
      providesTags: ['Onboarding'],
    }),

    updateOnboarding: build.mutation<UpdateOnboardingRes, UpdateOnboardingReq>({
      query: ({
        orgSlug,
        onboarding: { status, buildingId: building_id, zoneId: zone_id, employeeId: employee_id },
      }) => ({
        url: `/${orgSlug}/${apiVersion}/onboarding`,
        method: 'PUT',
        body: {
          status,
          building_id,
          zone_id,
          employee_id,
        },
      }),
      invalidatesTags: ['Onboarding'],
    }),
  }),
});

/**
 * Hooks
 */
export const { useFetchOnboardingQuery, useUpdateOnboardingMutation } = onboardingApi;

/**
 * Types
 */
type OrgSlug = {
  orgSlug: string;
};

type FetchOnboardingRes = any;
type FetchOnboardingReq = OrgSlug;

type UpdateOnboardingRes = any;
type Onboarding = {
  status: string;
  buildingId: number | null;
  zoneId: number | null;
  employeeId: number | null;
};
type UpdateOnboardingReq = OrgSlug & {
  onboarding: Onboarding;
};
